export default __webpack_public_path__ + "static/media/ic-unattempted-result.b620b1f5.svg";